<template>
	<div class="page">
		<navBar title="guarantee" v-if='UTILS.getEnv()'></navBar>
		<div class="privacy-container">
			<img src="../../assets/img/acceptance.png"/>
		</div>
	</div>
</template>

<script>
	import navBar from "@components/navBar";
	export default {
		data() {
			return {
				
			}
		},
		metaInfo: {
			title: 'guarantee'
		},
		components: {
			navBar
		},
		created: function() {
			
		},
		methods: {

		}
	}
</script>

<style scoped>
	.privacy-container{
		padding: 0.3rem;
	}
	h2{margin-bottom: 0.3rem;font-size: 0.30rem;}
	.cube-tab-bar{padding: 0 0 0.3rem 0.3rem;}
	p{font-size: 0.26rem;}
	.title{margin: 0.2rem 0;}
	.cube-tab-bar div{font-size: 0.26rem;}
	img{width: 100%;}
</style>
